module.exports = __webpack_public_path__ + "img/integralIcon1.4a11a8e8.png";